<template>
  <div class="grupo-familiar" v-loading="loading">
    <el-row>
      <div>
        <div class="beneficiarios">
          <div v-if="listaContrato.length">
            <el-button
              v-for="(contrato, index) in listaContrato"
              :key="index"
              :style="estiloBotao"
              @click="select(contrato)"
            >
              <div class="container">
                <div class="col1">
                  <div class="nome">
                    {{ contrato.descricaoContrato }}
                  </div>
                  <div class="row">
                    <div class="texto">
                      {{ contrato.numeroContrato }}
                    </div>
                  </div>
                </div>
                <div class="col2">
                  <div class="row">
                    <div
                      class="circle"
                      :style="{background: contrato.cor}"
                    >
                      <div class="abreviatura">
                        {{ contrato.abreviacao }}
                      </div>
                    </div>
                    '<i
                      style="margin-left: 15px"
                      :style="estiloIcone"
                      class="el-icon-arrow-right"
                    />'
                  </div>
                </div>
              </div>
            </el-button>
          </div>
          <div
            v-else
            style="background: #F6F6F6; padding: 15px; text-align: center; border-radius: 5px;  color: #909399;"
          >
            Não há beneficiários com acesso aos dados
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { mapListaByContratoOnly } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'

export default {
  name: 'GrupoFamiliarContratos',
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String
    }
  },
  watch: {
    value (newValue) {
      this.contratoSelecionado = newValue
    }
  },
  data () {
    return {
      contratoSelecionado: null,
      beneficiariosIntegracao: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['contratos']),
    ...mapState('SetupApp', ['apiGrupoFamiliar']),
    estiloBotao () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloIcone () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    visualizaContratosVazios () {
      if (!this.aplicacao.grupoFamiliar) {
        return true
      }

      return this.aplicacao.grupoFamiliar.visualizaContratosVazios
    },
    listaContrato () {
      if (this.loading) {
        return []
      }

      return mapListaByContratoOnly(this.contratos, this.beneficiariosIntegracao)
    }
  },
  methods: {
    async init () {
      try {
        this.beneficiariosIntegracao = await this.getGrupoFamiliar()
      } catch (ignored) {}
      this.loading = false
    },
    select (contrato) {
      // Propaga a mudança no valor
      this.$emit('input', contrato)
      this.$emit('click', contrato)
      this.contratoSelecionado = contrato
    },
    async getGrupoFamiliar () {
      if (this.apiGrupoFamiliar.grupoFamiliar) {
        const result = await this.apiGrupoFamiliar.grupoFamiliar({
          payload: {
            idFuncionalidade: this.idFuncionalidade
          },
          handlerErrorIgnore: true
        })

        if (!result.status) {
          return false
        }
        const { contratos } = result.data

        const invalid = contratos.filter(contrato => {
          return contrato.beneficiarios
        })

        if (invalid.length) {
          return false
        }
        return contratos
      }
      return false
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.container {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
}

.col1 {
  width: 80%;
  align-items: flex-start;
}

.col2 {
  padding-left: 13px;
}

.row {
  margin-top: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.circle {
  height: 35px;
  width: 35px;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nome {
  text-transform: none;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
}

.texto {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
}

.tipoBeneficiario {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
  margin-left: 5px;
  text-transform: capitalize;
}

.abreviatura {
  font-size: 17px;
  font-family: "Open Sans";
  color: #FFFFFF;
}
</style>
